import script from "./DataLink.vue?vue&type=script&setup=true&lang=js"
export * from "./DataLink.vue?vue&type=script&setup=true&lang=js"

import "./DataLink.vue?vue&type=style&index=0&id=f1222c30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1222c30"]])

export default __exports__